const wistiaReadApiKey = 'ed79df6a4d31ca84cd9d4af6268bb7bff174193e0bbaf34ab48788345812dd74';

export const wistiaVideoStatusEnum = {
  READY: 'ready',
  QUEUED: 'queued',
  PROCESSING: 'processing',
  failed: 'failed'
};

export const checkWistiaVideoStatus = async (videoId) => {
  try {
    const response = await fetch(
      'https://api.wistia.com/v1/medias/' + videoId + '.json?api_password=' + wistiaReadApiKey
    );
    const responseJson = await response.json();
    if (
      !responseJson
      || !responseJson.status
      || responseJson.error
      || responseJson.type !== 'Video'
    ) {
      return 'unknown';
    }
    console.log('returning actual status', responseJson.status);
    return responseJson.status;
  } catch (e) {
    console.log('error in fetching video status');
    return wistiaVideoStatusEnum.READY;
  }
};
